import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import { AccountExtraLink } from './AccountExtrasLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const PricingAndFeaturesLink = ({
  portalId,
  isDevPortal
}) => {
  const {
    t
  } = useTranslation();
  if (isDevPortal) {
    return null;
  }
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "productsAddons",
    link: `${getFullUrl('app')}/pricing/${portalId}?upgradeSource=nav-dropdown`,
    linkText: t('nav.tools.pricingAndFeatures'),
    isExternal: true,
    spaceAbove: true
  });
};